<div class="unit-details-description-section-container display-flex flex-column grid-gap-8">
  <div class="display-flex grid-gap-16 w-100">
    <div class="display-flex flex-column grid-gap-8 w-60">
      <ng-container *ngIf="!readOnly">
        <div class="display-flex grid-gap-48">
          <app-input
            [prefix]="'$'"
            [containerCss]="'number-style'"
            [contentCss]="'display-flex flex-column'"
            [attrLabel]="'Market rent'"
            [formControl]="marketRent"
            [showValidationError]="true"
          ></app-input>
          <app-input
            [prefix]="'$'"
            [containerCss]="'number-style'"
            [contentCss]="'display-flex flex-column'"
            [attrLabel]="'Adv. rent'"
            [formControl]="advertisedRent"
            [showValidationError]="true"
          ></app-input>
          <app-input
            [prefix]="'$'"
            [containerCss]="'number-style'"
            [contentCss]="'display-flex flex-column'"
            [attrLabel]="'Old rent'"
            [formControl]="oldRent"
            [showValidationError]="true"
          ></app-input>
          <app-input
            [prefix]="'$'"
            [containerCss]="'number-style'"
            [contentCss]="'display-flex flex-column'"
            [attrLabel]="'Rent'"
            [formControl]="rent"
            [showValidationError]="true"
          ></app-input>
        </div>
      </ng-container>
      <ng-container *ngIf="readOnly">
        <div class="display-flex grid-gap-48">
          <div class="body-small-bold">Market Rent:</div>
          <div class="display-flex grid-gap-8 align-items-center">
            <div class="body-small">{{ unit?.marketRent | currency: 'USD':'symbol':'1.0-0' }}</div>
            <mat-spinner *ngIf="renewalStrategyLoading$ | async" color="accent" diameter="20"></mat-spinner>
          </div>
          <div class="body-small-bold">Adv. Rent:</div>
          <div class="display-flex grid-gap-8 align-items-center">
            <div class="body-small">{{ unit?.advertisedRent | currency: 'USD':'symbol':'1.0-0' }}</div>
            <mat-spinner *ngIf="renewalStrategyLoading$ | async" color="accent" diameter="20"></mat-spinner>
          </div>
          <div class="body-small-bold">Old Rent:</div>
          <div class="display-flex grid-gap-8 align-items-center">
            <div class="body-small">{{ unit?.oldRent | currency: 'USD':'symbol':'1.0-0' }}</div>
            <mat-spinner *ngIf="renewalStrategyLoading$ | async" color="accent" diameter="20"></mat-spinner>
          </div>
          <div class="body-small-bold">Rent:</div>
          <div class="display-flex grid-gap-8 align-items-center">
            <div class="body-small">{{ unit?.rent | currency: 'USD':'symbol':'1.0-0' }}</div>
            <mat-spinner *ngIf="renewalStrategyLoading$ | async" color="accent" diameter="20"></mat-spinner>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
